import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { getCategoriesWithCount } from "../../../services/userservice";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategoriesWithCount()
      .then(data => {
        // Group categories into columns of 7 items each
        const groupedCategories = [];
        const itemsPerColumn = 7;
        
        for (let i = 0; i < data.length; i += itemsPerColumn) {
          groupedCategories.push({
            id: Math.floor(i / itemsPerColumn) + 1,
            jobCategories: data.slice(i, i + itemsPerColumn).map(cat => ({
              id: cat.id,
              jobName: cat.category_name,
              jobNumbers: cat.job_count
            }))
          });
        }
        
        setCategories(groupedCategories);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching categories:", error);
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <React.Fragment>
        <section className="section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6}>
                <div className="text-center">
                  <p>Cargando categorías...</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6}>
              <div className="text-center mb-5">
                <p className="badge bg-info fs-14 mb-2">Oportunidades de empleo</p>
                <h4>Buscar Por Categoria</h4>
                <p className="text-muted">
                Selecciona la categoría que se ajusta a tu perfil profesional, así encontraras de manera ágil las ofertas de empleo que más se relacionan a tu experiencia laboral.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            {categories.map((categoriesDetails, key) => (
              <Col lg={4} key={key}>
                <Card className="job-Categories-box bg-light border-0">
                  <CardBody className="p-4">
                    <ul className="list-unstyled job-Categories-list mb-0">
                      {(categoriesDetails.jobCategories || []).map(
                        (jobCategoriesDetails, key) => (
                          <li key={key} className="job-category-item">
                            <Link 
                              to={`/jobgrid?category=${jobCategoriesDetails.id}`} 
                              className="primary-link d-flex justify-content-between align-items-center"
                            >
                              {jobCategoriesDetails.jobName}
                              <span className="badge bg-info-subtle text-info">
                                {jobCategoriesDetails.jobNumbers}
                              </span>
                            </Link>
                          </li>
                        )
                      )}
                    </ul>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Categories;
